export default "__VITE_ASSET__bef0122b__"